import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { blueColor } from 'js/config/style';

const Container = styled.div`
  text-align: center;
  margin-bottom: 1rem;
`;

const LockIcon = styled(Icon).attrs({ name: 'lock' })`
  font-size: 3rem;
  color: ${blueColor};
`;

export default () => (
  <Container>
    <LockIcon />
  </Container>
);
